/// <amd-module name="Search/Package/Components/FilterPaneContainer" />

import * as React from "react";
import * as Container from "Search/Shared/Base/Container";
import { ActionCreator } from "Search/Package/Flux/ActionCreator";
import { StoresHub, IAggregatedState, StoreName } from "Search/Package/Flux/StoresHub"
import { FilterPane } from "Search/Package/Components/FilterPane";

export const FilterPaneContainer = Container.create<StoreName, ActionCreator, IAggregatedState, StoresHub>(
    [
        "filterStore"
    ],
    ({
        filterStoreState,
        searchStoreState,
        isProjectContext
    }, props) => {
        const { filterItemsVisible } = filterStoreState;

        return (
            <>
                {
                    filterItemsVisible ? (
                        <div className="search-filters-container">
                            <FilterPane
                                searchStoreState={searchStoreState}
                                filterStoreState={filterStoreState}
                                isProjectContext={isProjectContext}
                                {...props}
                            />
                        </div>
                    ) : null
                }
            </>
        );
    });